import React, { useRef, useState, useEffect } from 'react';
import styles from './seopudinzim.module.scss';
import Perfil from './src/perfil.png';

const Seopudinzim: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.seopudinzim}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]} aria-hidden="true" />
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <div className={styles.links}>
                        {[
                            {
                                title: 'Faça seu pedido',
                                href: 'https://pinktech.com.br/menu/seopudinzim',
                            },
                            {
                                title: 'Whatsapp',
                                href: 'https://wa.me/5517992163906?text=Olá, vim pelo link na bio e gostaria de mais informações...',
                            },
                            {
                                title: 'Localização',
                                href: 'https://maps.app.goo.gl/PbwDHNeJzd3mFyeAA',
                            },
                            {
                                title: 'Instagram',
                                href: 'https://www.instagram.com/seopudinzim?igsh=b2g2ZnQ2dmtsY2M1',
                            },
                        ].map(({ title, href }, index) => (
                            <a
                                key={index}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    background: '#F8F6F0',
                                    transition: 'background 0.5s ease',
                                    color: '#7A2F22',
                                    textAlign: 'center',
                                    padding: '5px 0px',
                                    borderRadius: '20px',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#FDC27D';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = '#F8F6F0';
                                }}
                            >
                                <span style={{ letterSpacing: '2px', fontSize: '14px', fontWeight: 700 }}>
                                    {title}
                                </span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Seopudinzim;
